// Mock data for PURA Ukraine website

export const products = [
  {
    id: 1,
    category: 'pura-4',
    title: 'PURA-4',
    description: 'Продуктивність 0,6 м³ стічних вод на добу, що підходить для домогосподарства з 2–4 мешканцями. Конструкція оснащена кільцями жорсткості та передбачає простий, швидкий монтаж.',
    features: [
      'Продуктивність 0,6 м³/добу',
      'Для 2-4 мешканців',
      'Кільця жорсткості',
      'Простий монтаж',
      'Компактні розміри',
      'Надійна конструкція'
    ],
    applications: [
      'Невеликі приватні будинки',
      'Дачі',
      'Котеджі для 2-4 осіб'
    ],
    image: 'https://customer-assets.emergentagent.com/job_31e69c46-4689-4a12-a008-5ee9b9af5120/artifacts/ivd047xc_WhatsApp%20Image%202026-02-10%20at%2011.42.07%20%282%29.jpeg',
    price: 119808,
    specifications: {
      capacity: '0,6 м³/добу',
      users: '2-4 мешканці',
      material: 'Поліпропілен (PP)'
    }
  },
  {
    id: 2,
    category: 'pura-6',
    title: 'PURA-6',
    description: 'Продуктивність 0,8 м³ стічних вод на добу, що оптимально для домогосподарства з 4–6 мешканцями. Обладнана кільцями жорсткості та передбачає простий монтаж.',
    features: [
      'Продуктивність 0,8 м³/добу',
      'Для 4-6 мешканців',
      'Кільця жорсткості',
      'Швидкий монтаж',
      'Оптимальні розміри',
      'Довговічність'
    ],
    applications: [
      'Приватні будинки',
      'Котеджі для сім\'ї',
      'Заміські будинки'
    ],
    image: 'https://customer-assets.emergentagent.com/job_31e69c46-4689-4a12-a008-5ee9b9af5120/artifacts/ox567s1f_WhatsApp%20Image%202026-02-10%20at%2011.42.07%20%281%29.jpeg',
    price: 129792,
    specifications: {
      capacity: '0,8 м³/добу',
      users: '4-6 мешканців',
      material: 'Поліпропілен (PP)'
    }
  },
  {
    id: 3,
    category: 'pura-9',
    title: 'PURA-9',
    description: 'Продуктивність – 1,35 м³ стічних вод на добу, що підходить для домогосподарства з 6–9 мешканцями. Корпус має кільця жорсткості, завдяки чому витримує ґрунтовий тиск. Конструкція передбачає простий та швидкий монтаж без складних будівельних робіт.',
    features: [
      'Продуктивність 1,35 м³/добу',
      'Для 6-9 мешканців',
      'Кільця жорсткості',
      'Витримує ґрунтовий тиск',
      'Простий монтаж',
      'Європейська якість'
    ],
    applications: [
      'Великі приватні будинки',
      'Котеджі',
      'Будинки постійного проживання'
    ],
    image: 'https://customer-assets.emergentagent.com/job_31e69c46-4689-4a12-a008-5ee9b9af5120/artifacts/g3qlp6p9_WhatsApp%20Image%202026-02-10%20at%2011.42.07.jpeg',
    price: 194688,
    specifications: {
      capacity: '1,35 м³/добу',
      users: '6-9 мешканців',
      material: 'Поліпропілен (PP)'
    }
  },
  {
    id: 4,
    category: 'private-houses',
    title: 'Системи для Приватних Будинків',
    description: 'Компактні та енергоефективні станції біологічної очистки PURA для котеджів і дач (від 4 до 10 осіб). Забезпечують стабільну роботу та не потребують складного обслуговування.',
    features: [
      'Очищення стоків до 98%',
      'Відповідність стандартам EN 12566',
      'Компактні розміри',
      'Мінімальне обслуговування',
      'Енергоефективність',
      'Простий монтаж'
    ],
    applications: [
      'Приватні будинки та котеджі',
      'Дачі та заміські будинки',
      'Невеликі садиби',
      'Індивідуальні домогосподарства'
    ],
    image: 'https://customer-assets.emergentagent.com/job_31e69c46-4689-4a12-a008-5ee9b9af5120/artifacts/dj2ylqyp_2-600x600.jpg',
    specifications: {
      capacity: 'PURA-4, PURA-6, PURA-9',
      material: 'Поліпропілен (PP)',
      warranty: 'Офіційна гарантія'
    }
  },
  {
    id: 5,
    category: 'commercial',
    title: 'Рішення для Комерційних Об\'єктів',
    description: 'Великі системи очищення для готелів, баз відпочинку, малих підприємств та житлових комплексів. Розраховані до 50 мешканців з можливістю індивідуального проєктування.',
    features: [
      'Висока продуктивність',
      'Промисловий рівень очистки',
      'Надійна конструкція',
      'Адаптація під об\'єкт',
      'Сертифікація ЄС (CE)',
      'Довговічність'
    ],
    applications: [
      'Готелі та бази відпочинку',
      'Ресторани та кафе',
      'Невеликі житлові комплекси',
      'Офісні центри',
      'Комерційні об\'єкти'
    ],
    image: 'https://customer-assets.emergentagent.com/job_31e69c46-4689-4a12-a008-5ee9b9af5120/artifacts/uso5k3ot_11.jpg',
    specifications: {
      capacity: 'До 50 мешканців',
      material: 'Поліпропілен (PP)',
      certification: 'Сертифікація ЄС (CE)'
    }
  },
  {
    id: 6,
    category: 'custom',
    title: 'Нестандартні Пластикові Вироби',
    description: 'Індивідуальні пластикові вироби за кресленнями та технічними вимогами замовника. Адаптація конструкції під конкретні умови монтажу й функції.',
    features: [
      'Індивідуальний дизайн',
      'Аналіз реальних умов об\'єкту',
      'Високоякісний поліпропілен (PP) або поліетилен (PE)',
      'Стійкість до корозії та хімічного впливу',
      'Точна відповідність вимогам',
      'Професійне проєктування'
    ],
    applications: [
      'Нестандартні ємності',
      'Спеціалізовані резервуари',
      'Технологічні пристрої',
      'Індивідуальні інженерні рішення'
    ],
    image: 'https://customer-assets.emergentagent.com/job_31e69c46-4689-4a12-a008-5ee9b9af5120/artifacts/o13g1da5_15.jpg',
    specifications: {
      customization: 'Повна кастомізація',
      material: 'PP або PE',
      delivery: 'Індивідуальні терміни'
    }
  }
];

export const projects = [
  {
    id: 1,
    category: 'private',
    title: 'Приватний будинок, Київська область',
    description: 'Встановлення станції біологічної очистки для сім\'ї з 6 осіб. Об\'єкт розташований поза межами централізованої каналізації.',
    capacity: '6 користувачів',
    solution: 'Станція біологічної очистки PT-6',
    year: 2024,
    challenge: 'Відсутність центральної каналізації, високий рівень ґрунтових вод',
    result: 'Повністю автономна система очищення стоків з можливістю скидання очищеної води у грунт',
    image: 'https://images.unsplash.com/photo-1622322977879-af6982dcba00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHx3YXRlciUyMHRyZWF0bWVudCUyMHBsYW50fGVufDB8fHx8MTc2NjA1MDQxNHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    category: 'hotel',
    title: 'Готельно-ресторанний комплекс, Львівська область',
    description: 'Комплексна система водовідведення для готелю на 50 номерів з рестораном та SPA-зоною.',
    capacity: '200+ користувачів',
    solution: 'Станція біологічної очистки PT-200 + резервуари технічної води',
    year: 2023,
    challenge: 'Нерівномірне навантаження, сезонність проживання, високі вимоги до якості очищення',
    result: 'Надійна система з можливістю повторного використання очищеної води для технічних потреб',
    image: 'https://images.unsplash.com/photo-1533077162801-86490c593afb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHx3YXRlciUyMHRyZWF0bWVudCUyMHBsYW50fGVufDB8fHx8MTc2NjA1MDQxNHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    category: 'industrial',
    title: 'Агропідприємство, Вінницька область',
    description: 'Система водопостачання та очистки стічних вод для тваринницької ферми.',
    capacity: 'Промислове використання',
    solution: 'Резервуари питної води 25м³ + система очистки стоків',
    year: 2024,
    challenge: 'Велика кількість стоків, необхідність резервування води, жорсткі умови експлуатації',
    result: 'Комплексна система, що забезпечує безперебійну роботу підприємства цілий рік',
    image: 'https://images.unsplash.com/photo-1638294834907-d11608bc11d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwdGFua3xlbnwwfHx8fDE3NjYwNTA0MjZ8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    category: 'residential',
    title: 'Котеджне містечко, Одеська область',
    description: 'Централізована система очищення стоків для котеджного містечка з 45 будинків.',
    capacity: '180 користувачів',
    solution: 'Модульна станція біологічної очистки PT-180',
    year: 2023,
    challenge: 'Поетапне будівництво містечка, можливість розширення системи',
    result: 'Модульна система з можливістю нарощування потужності у міру забудови',
    image: 'https://images.pexels.com/photos/31940460/pexels-photo-31940460.jpeg'
  },
  {
    id: 5,
    category: 'logistics',
    title: 'Логістичний комплекс, Дніпропетровська область',
    description: 'Резервуари для водопостачання та протипожежні резервуари для складського комплексу.',
    capacity: 'Промислове використання',
    solution: 'Резервуари загальним об\'ємом 150м³',
    year: 2024,
    challenge: 'Великий об\'єм споживання води, вимоги пожежної безпеки',
    result: 'Надійна система водопостачання з резервом для протипожежних потреб',
    image: 'https://images.pexels.com/photos/12634302/pexels-photo-12634302.jpeg'
  },
  {
    id: 6,
    category: 'restaurant',
    title: 'Ресторан, Харківська область',
    description: 'Система очищення стічних вод для ресторану з кухнею повного циклу.',
    capacity: '50 відвідувачів',
    solution: 'Станція біологічної очистки PT-50 + жировловлювач',
    year: 2023,
    challenge: 'Високий вміст жирів у стоках, строгі санітарні вимоги',
    result: 'Ефективна система очищення з додатковим жировловлювачем',
    image: 'https://images.pexels.com/photos/24802113/pexels-photo-24802113.jpeg'
  }
];

export const advantages = [
  {
    id: 1,
    title: 'Системи для Приватних Будинків',
    description: 'Компактні та енергоефективні установки PURA для 4–10 осіб, які забезпечують стабільну роботу та не потребують складного обслуговування',
    icon: 'CheckCircle2'
  },
  {
    id: 2,
    title: 'Рішення для Комерційних Об\'єктів',
    description: 'Більші системи до 50 мешканців для готелів, баз відпочинку й невеликих житлових комплексів з індивідуальним проєктуванням',
    icon: 'MapPin'
  },
  {
    id: 3,
    title: 'Монтаж "Під Ключ" та Сервіс',
    description: 'Професійне встановлення, пусконалагодження та подальший сервіс для безвідмовної роботи протягом усього строку експлуатації',
    icon: 'Headphones'
  },
  {
    id: 4,
    title: 'Ексклюзивна Якість та Гарантія',
    description: 'Сертифіковані системи з високим ступенем очищення стоків до 98%, надійною конструкцією та офіційною гарантією від імпортера',
    icon: 'Zap'
  },
  {
    id: 5,
    title: 'Індивідуальний Підхід',
    description: 'Нестандартні пластикові вироби за кресленнями та технічними вимогами, адаптовані під конкретні умови вашого об\'єкту',
    icon: 'Shield'
  },
  {
    id: 6,
    title: 'Європейські Стандарти',
    description: 'Сертифікація ЄС (CE), відповідність стандартам EN 12566, високоякісний поліпропілен та поліетилен',
    icon: 'Leaf'
  }
];

export const partnerBenefits = [
  {
    id: 1,
    title: 'Якісне європейське обладнання',
    description: 'Офіційне представництво Plastic Technology з гарантією якості та сертифікатами',
    icon: 'Award'
  },
  {
    id: 2,
    title: 'Технічна підтримка',
    description: 'Консультації інженерів на всіх етапах проєкту, допомога у підборі рішень',
    icon: 'HeadphonesIcon'
  },
  {
    id: 3,
    title: 'Навчання та сертифікація',
    description: 'Безкоштовні тренінги з монтажу, налаштування та обслуговування обладнання',
    icon: 'GraduationCap'
  },
  {
    id: 4,
    title: 'Вигідні комерційні умови',
    description: 'Спеціальні ціни для партнерів, система знижок, гнучкі умови оплати',
    icon: 'TrendingUp'
  },
  {
    id: 5,
    title: 'Маркетингова підтримка',
    description: 'Рекламні матеріали, зразки продукції, спільні маркетингові активності',
    icon: 'Megaphone'
  },
  {
    id: 6,
    title: 'Індивідуальні рішення',
    description: 'Можливість замовлення нестандартних виробів під конкретний проєкт',
    icon: 'Wrench'
  }
];

export const documents = [
  {
    id: 1,
    title: 'Сертифікат CE',
    category: 'certificates',
    description: 'Сертифікат відповідності європейським стандартам',
    fileName: 'CE_Certificate.pdf',
    size: '2.4 MB',
    downloadUrl: '#'
  },
  {
    id: 2,
    title: 'Технічний паспорт станції очистки',
    category: 'technical',
    description: 'Детальні технічні характеристики та схеми підключення',
    fileName: 'Technical_Passport_PT.pdf',
    size: '5.1 MB',
    downloadUrl: '#'
  },
  {
    id: 3,
    title: 'Інструкція з експлуатації резервуарів',
    category: 'manuals',
    description: 'Керівництво з використання та обслуговування',
    fileName: 'Reservoir_Manual.pdf',
    size: '3.2 MB',
    downloadUrl: '#'
  },
  {
    id: 4,
    title: 'Каталог продукції 2024',
    category: 'catalogs',
    description: 'Повний каталог з цінами та характеристиками',
    fileName: 'Product_Catalog_2024.pdf',
    size: '12.8 MB',
    downloadUrl: '#'
  },
  {
    id: 5,
    title: 'Гігієнічний сертифікат',
    category: 'certificates',
    description: 'Висновок державної санітарно-епідеміологічної експертизи',
    fileName: 'Hygiene_Certificate.pdf',
    size: '1.8 MB',
    downloadUrl: '#'
  }
];

export const faqData = [
  {
    id: 1,
    question: 'Яка гарантія на обладнання?',
    answer: 'Ми надаємо гарантію 10 років на пластикові корпуси станцій очистки та резервуарів. На електронне обладнання та компресори – 2 роки. Термін служби обладнання становить 50+ років.'
  },
  {
    id: 2,
    question: 'Чи працює система при відключенні електрики?',
    answer: 'Станції біологічної очистки потребують електроживлення для роботи компресора, але споживають мінімум енергії (30-60 Вт). Можливе підключення до резервного джерела живлення. Резервуари та септики працюють повністю автономно.'
  },
  {
    id: 3,
    question: 'Як часто потрібне обслуговування?',
    answer: 'Станції біологічної очистки потребують технічного огляду раз на рік. Видалення надлишкового мулу – 1-2 рази на рік залежно від інтенсивності використання. Обслуговування просте і може виконуватись власними силами після інструктажу.'
  },
  {
    id: 4,
    question: 'Чи можна встановити систему взимку?',
    answer: 'Так, монтаж можливий цілий рік. Однак земляні роботи зимою можуть бути ускладнені через промерзлий ґрунт. Оптимальний період для встановлення – весна-осінь.'
  },
  {
    id: 5,
    question: 'Які дозвільні документи потрібні?',
    answer: 'Для приватних будинків дозвільна документація не потрібна. Для промислових об\'єктів необхідний проєкт водовідведення та дозвіл місцевих екологічних служб. Ми допоможемо з підготовкою необхідної документації.'
  }
];

export const contactInfo = {
  company: 'ТОВ "PURA УКРАЇНА"',
  phone: '+380 68 922 02 26',
  phoneLink: '+380689220226',
  phones: [
    { number: '+380 68 922 02 26', link: '+380689220226' }
  ],
  email: 'puraukraine@gmail.com',
  contact: 'Павло',
  address: '1-й Водопійний провулок, 21, Біла Церква, Київська область, 09100',
  city: 'Біла Церква',
  workingHours: 'Пн-Пт: 9:00 - 18:00',
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61587409194187',
    linkedin: '#',
    instagram: 'https://www.instagram.com/pura.ukraine?igsh=M2NsY3d0bGp2OHU1'
  }
};
